import { Grid } from "@sidelinesports/fan-design-system";
import { Page } from "../../analytics/Page.tsx";
import { FullscreenFixedLayout } from "../../components";
import { useConditionalGameRedirect } from "./hooks/use-conditional-game-redirect.ts";
import styles from "./PlayGamePage.module.css";
import {
  MessageController,
  MostRecentFeaturedMessageToaster,
  PageHeader,
  PlayerCardsSection,
  RundownSection,
  UnderCardSection,
} from "./sections";

export const PlayGamePage = () => {
  useConditionalGameRedirect();

  return (
    <Page name="PlayGame">
      <FullscreenFixedLayout className={styles.layout} header={<PageHeader />}>
        <MessageController />
        <Grid gap={16} py={24} style={{ overflowX: "hidden" }}>
          <RundownSection />
          <PlayerCardsSection />
          <UnderCardSection />
        </Grid>
      </FullscreenFixedLayout>
      <MostRecentFeaturedMessageToaster />
    </Page>
  );
};
